export default __webpack_public_path__ + "static/media/kompacto.682e76fa.jpg";